// extracted by mini-css-extract-plugin
export default {"TwoDimsFeature":"wc_a bhi_b bhi_wb"};